const { createEventUrl, createNewsUrl } = require('./utils');

const { orderBy } = require ('lodash');

/**
 * Create the guide categories. Iterates over the news
 * list to get the list of categories / subcategories
 * Sort the list of categoris by ranking
 * @param {*} news - the news list
 * @returns
 */


const getGuideCategories = (news) => {
  const subcategories = {};
  const categories = {};

  news.forEach(n => {
    (n.subcategories || []).forEach(s => {
      subcategories[s.id] = {
        ...s,
        type: 'subcategory'
      };
    });
  });

  news.forEach(n => {
    (n.categories || []).forEach(c => {
      if (!categories[c.id]) {
        categories[c.id] = {
          cnt: 1,
          type: 'category',
          label: c.label,
          subcategories : ((c.subcategories || [])
            .map(sub => {
              return subcategories[sub.id];
            }))
            .filter(Boolean)
        };
      } else {
        categories[c.id].cnt = categories[c.id].cnt + 1;
      }
    });
  });
  return orderBy(Object.values(categories), ['cnt'], ['desc']);
};

/**
 * Returns the header and the page news
 * @param {*} guide
 * @param {*} pagination
 * @returns
 */
/*
const toNewsGuide = (guide, pagination) => {
    const { headerNews, news: bodyNews, news_per_page } = guide;
    const headerIds = (headerNews || []).map((e) => e.id);

    const allNews = (bodyNews || []).filter((e) => !headerIds.includes(e.id));
    let news = allNews;
    if (pagination) {
      const startIdx = pagination.pageIndex * news_per_page;
      const endIdx = Math.min(startIdx + news_per_page, allNews.length);
      news = [...allNews.slice(startIdx, endIdx)];
    }

    return {
      guideHeaderNews: headerNews,
      guideBodyNews: news,
      totalNews: allNews.length,
    };
  };
  */

/**
   * Calculates the header news
   */
const getHeaderNews = (headerNews, locale, websiteRoot) => {
  return headerNews.filter(n => n).map((news) => {
    return {
      title: news.title,
      id: news.id,
      heading: news.heading,
      newWindow: true,
      media: news.cover,
      news_item: news,
      slug: createNewsUrl(news.slug, locale, websiteRoot),
    };
  });
};

/**
   * Calculates the current page body news
   */
const getBodyNews = (bodyNews, locale, websiteRoot) => {
  return bodyNews.filter(n => n).map((news) => {
    return {
      ...news,
      slug: createNewsUrl(news.slug, locale, websiteRoot),
    };
  });
};


/**
 * Returns the header and the page events
 * @param {*} guide
 * @param {*} pagination
 * @returns
 */
/*
const toEventsGuide = (guide, pagination) => {
    const {header_events, events : body_events, events_per_page} = guide
    const headerIds = (header_events || []).map(e => e.id)
    // By default : only the events to come
    const now = new Date().toISOString()
    const allEvents = (body_events || [])
          .filter(e => !headerIds.includes(e.id))
          .filter(e => e.start_date >= now)
    let events = allEvents
    if (pagination) {
      const startIdx = pagination.pageIndex * events_per_page
      const endIdx = Math.min(startIdx + events_per_page, allEvents.length)
      events = [...allEvents.slice(startIdx, endIdx)]
    }
    return {headerEvts: header_events, bodyEvts: events}
  }
  */

/**
   * Header events
   */
const getHeaderEvents = (headerEvts, locale, websiteRoot) => {
  return headerEvts.filter(n => n).map(evt => {
    return {
      title: evt.title,
      id: evt.id,
      heading: evt.heading,
      newWindow: true,
      media: evt.cover,
      event: evt,
      slug: createEventUrl(evt.slug, locale, websiteRoot)
    };
  });
};

/**
   * Prepare the body events
   */
const getBodyEvents = (bodyEvts, locale, websiteRoot) => {
  return bodyEvts.filter(n => n).map(evt => {
    return {
      ...evt,
      slug: createEventUrl(evt.slug, locale, websiteRoot)
    };
  });
};

module.exports = {
  getGuideCategories,
  getBodyEvents,
  getHeaderEvents,
  getBodyNews,
  getHeaderNews
};
